import { render, staticRenderFns } from "./DatasourceConfigAdmin.vue?vue&type=template&id=d075d69e&scoped=true&"
import script from "./DatasourceConfigAdmin.vue?vue&type=script&lang=js&"
export * from "./DatasourceConfigAdmin.vue?vue&type=script&lang=js&"
import style0 from "./DatasourceConfigAdmin.vue?vue&type=style&index=0&id=d075d69e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d075d69e",
  null
  
)

export default component.exports